import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';

const ServiceHero = () => (
  <section className="pt-[110px] pb-14 sm:pb-20 px-4 sm:px-6 bg-[#FFF4F8]">
    <div className="max-w-[75rem] mx-auto text-center">
      <h2 className="text-[#966376] font-sans text-base sm:text-lg font-semibold uppercase tracking-widest mb-4">
        OUR SERVICES
      </h2>
      <h1
        style={{ lineHeight: 1.15 }}
        className="text-[#0B2549] font-regrade text-4xl sm:text-5xl md:text-6xl font-bold mb-6"
      >
        End-to-End Facility &<br className="hidden sm:block" /> Security Solutions
      </h1>
      <p className="text-[#6D7E94] text-sm sm:text-base font-[500] max-w-2xl mx-auto mb-8 leading-relaxed">
        Professional housekeeping, security, and manpower outsourcing — all under one roof.
        We help businesses run smoothly so you can focus on what matters most.
      </p>
      <Link to="/contact">
        <Button
          style={{ borderRadius: '30px' }}
          className="text-white px-8 rounded-[30px] hover:bg-[#7d5262] transition-colors"
        >
          Get in Touch
        </Button>
      </Link>
    </div>
  </section>
);

export default ServiceHero;
